import React from "react";
import IconButton from "@mui/material/IconButton";
import EditIcon from "@mui/icons-material/Edit";
import { RestoreFromTrashOutlined } from "@mui/icons-material";
import PermissionRestrictedComponent from "../PermissionRestrictedComponent";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import Iconify from "../Icons/Iconify";

// Define the structure of your Actions component
interface DataTableActionsProps {
  onEdit?: () => void;
  onView?: (() => void) | null;
  onDelete?: () => void;
  onUpload?: (() => void) | null;
  onPrint?: (() => void) | null;
  onSendEmail?: (() => void) | null;
  onRestore?: () => void;
  isActive?: boolean;
  permissionUpdate?: number;
  permissionDeleteRestore?: number;
  permissionPrint?: number;
  permissionEmail?: number;
  permissionUpload?: number;
  disableButtons?: boolean;
  editDisable?: boolean;
  deleteDisable?: boolean;

  showDelete?: boolean;
}

// Implement the Actions component
class DataTableActions extends React.Component<DataTableActionsProps> {
  render() {
    const {
      onEdit,
      onView,
      onDelete,
      onPrint,
      onUpload,
      onSendEmail,
      isActive,
      onRestore,
      permissionUpdate,
      permissionDeleteRestore,
      permissionPrint,
      permissionEmail,
      permissionUpload,
      disableButtons,
      editDisable,
      deleteDisable,

      showDelete = true,
    } = this.props;
  
    return (
      <>
        {isActive !== false ? (
          <>
            {onEdit && (
              <PermissionRestrictedComponent
                permission={permissionUpdate || null}
              >
                <IconButton
                  onClick={onEdit}
                  aria-label="Edit"
                  size="small"
                  color="secondary"
                  disabled={!!editDisable}
                >
                  <Iconify icon={"fa-regular:edit"} />
                </IconButton>
              </PermissionRestrictedComponent>
            )}

            {onView && (
              <PermissionRestrictedComponent
                permission={permissionDeleteRestore || 0}
              >
                <IconButton
                  onClick={onView}
                  aria-label="View"
                  size="small"
                  color="primary"
                >
                  <Iconify icon={"iconamoon:eye-light"} />
                </IconButton>
              </PermissionRestrictedComponent>
            )}
            {onPrint && (
              <PermissionRestrictedComponent
                permission={permissionDeleteRestore || 0}
              >
                <IconButton
                  onClick={onPrint}
                  aria-label="Print"
                  size="small"
                  color="secondary"
                >
                  <Iconify icon={"mdi:printer-outline"} />
                </IconButton>
              </PermissionRestrictedComponent>
            )}
            {onSendEmail && (
              <PermissionRestrictedComponent
                permission={permissionDeleteRestore || 0}
              >
                <IconButton
                  onClick={onSendEmail}
                  aria-label="email"
                  size="small"
                  color="secondary"
                  sx={{
                    color: (theme) => `${theme.palette.primary} !important`,
                  }}
                >
                  <Iconify icon={"clarity:email-line"} />
                </IconButton>
              </PermissionRestrictedComponent>
            )}
            {onUpload && (
              <PermissionRestrictedComponent permission={permissionUpdate || 0}>
                <IconButton
                  onClick={onUpload}
                  aria-label="image"
                  size="small"
                  color="secondary"
                  sx={{
                    color: (theme) => `${theme.palette.primary} !important`,
                  }}
                >
                  <Iconify icon={"gridicons:cloud-upload"} />
                </IconButton>
              </PermissionRestrictedComponent>
            )}
            {onDelete && showDelete && (
              <PermissionRestrictedComponent
                permission={permissionDeleteRestore || 0}
              >
                <IconButton
                  onClick={onDelete}
                  aria-label="Delete"
                  size="small"
                  color="error"
                  disabled={disableButtons || !!deleteDisable}
                >
                  <DeleteOutlineOutlinedIcon fontSize="small" />
                </IconButton>
              </PermissionRestrictedComponent>
            )}
          </>
        ) : (
          onRestore && (
            <PermissionRestrictedComponent
              permission={permissionDeleteRestore || 0}
            >
              <IconButton
                onClick={onRestore}
                aria-label="Restore"
                size="small"
                color="error"
              >
                <RestoreFromTrashOutlined />
              </IconButton>
            </PermissionRestrictedComponent>
          )
        )}
      </>
    );
  }
}

export default DataTableActions;
